import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import type { NavLinkItem, NavMenu } from '../../data/navigation';
type NavMenuPanelProps = {
  menu: NavMenu;
};
const colClass: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3'
};
export function NavMenuPanel({
  menu
}: NavMenuPanelProps) {
  const groups = menu.groups ?? [];
  return <div className="w-full px-5 pb-6 pt-7" data-id="element-894" data-mp="57aapnj10l5n">
      <div className="space-y-8" data-id="element-895" data-mp="544oqh5p1ze5">
        {groups.map(group => <div key={group.heading} data-id="element-896" data-mp="a4saanb5lo0z">
            <p className="text-[11.5px] font-medium uppercase tracking-[0.1em] text-ink-muted" data-id="element-897" data-mp="a2xx5v64j07g">{group.heading}</p>
            <ul className={`mt-3 grid gap-x-8 gap-y-1 ${colClass[group.columns]}`} data-id="element-898" data-mp="14dmnhapvwub">
              {group.items.map(item => <li key={item.label} data-id="element-899" data-mp="2guqdh68tc5iu">
                  <MenuLink item={item} data-id="element-900" data-mp="2gxuskyntgloa" />
                </li>)}
            </ul>
          </div>)}
      </div>

      {menu.footerLink && <div className="mt-6 border-t border-canvas-line pt-5" data-id="element-901" data-mp="15ud9kgzt5sft">
          <SmartLink href={menu.footerLink.href} className="group inline-flex items-center gap-2 text-[15px] font-medium text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-902" data-mp="10uh4sfjadwz7">
            {menu.footerLink.label}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-903" data-mp="1auhs0cka0x8o" />
          </SmartLink>
        </div>}
    </div>;
}
function MenuLink({
  item
}: {
  item: NavLinkItem;
}) {
  const Icon = item.icon;
  return <SmartLink href={item.href} className="group -mx-2 flex items-center gap-3 rounded-[10px] px-2 py-2 transition-colors duration-150 ease-out hover:bg-canvas-sky focus-visible:bg-canvas-sky focus-visible:outline-none" data-id="element-904" data-mp="1tiwm58pw4rdp">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] bg-[#F1F1EF] text-ink ring-1 ring-inset ring-ink/[0.06] transition-colors duration-150 ease-out group-hover:bg-white group-hover:text-brand" data-id="element-905" data-mp="23i3yptoswhzr">
        <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-906" data-mp="2fh98mewl4wcr" />
      </span>
      <span className="min-w-0" data-id="element-907" data-mp="2kh5dshh0qttw">
        <span className="block truncate text-[15px] font-medium leading-tight text-ink" data-id="element-908" data-mp="2p8wum0adhl6u">{item.label}</span>
        <span className="mt-1 block truncate text-[13px] leading-[1.35] text-ink-muted" data-id="element-909" data-mp="2tb9ysk9h1b1i">{item.description}</span>
      </span>
    </SmartLink>;
}